// extracted by mini-css-extract-plugin
module.exports = {"icon":"_2drT9","more":"b87RF","actions":"_20VJk","actionsTop":"_2UAJi"};